'use client';
import { useBP } from 'scripts';
import { CSSProperties, useMemo } from 'react';
import { Drawer, Modal, Spin } from 'antd';
import { __PostContactPropsType } from './postContact.type';
import dynamic from 'next/dynamic';
import { __SocialMedias } from 'mrCity/panel/postForm/socialMedia/socialMedia.data';
import { COLORS } from 'utilities';

export default function PostContactComp(props: __PostContactPropsType) {
    const isMobile = useBP()?.MD_LTE;
    const post = props.post;
    const social = (name: string) => __SocialMedias.find((i) => i.name === name);
    const Map = useMemo(
        () =>
            dynamic(() => import('components/locationPicker/locationPicker.index'), {
                loading: () => (
                    <div className={`w-100 pv-9 center-content flex-1`}>
                        <Spin />
                    </div>
                ),
                ssr: false,
            }),
        [],
    );

    const style: CSSProperties = {
        borderRadius: 10,
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fbe4d6',
        color: COLORS.primary,
        minWidth: 120,
        padding: '12px 12px',
    };

    const content = (
        <>
            <div style={{ gap: 16, flexWrap: 'wrap' }} className={`center-content-x mb-3`}>
                {post.has_phone && post.phone?.length ? (
                    <a target="_blank" href={'tel:' + post.phone} style={style}>
                        تماس تلفنی
                    </a>
                ) : null}
                {Object.entries(post.socials ?? '{}')
                    .filter((i) => i[1].length)
                    .map((item, index) =>
                        social(item[0]) ? (
                            <a key={index} aria-label={item[0]} target="_blank" href={item[1] as string} style={style}>
                                {social(item[0])?.label}
                            </a>
                        ) : null,
                    )}
            </div>
            <Map latitude={post.latitude} longitude={post.longitude} />
        </>
    );

    return isMobile ? (
        <Drawer placement="bottom" open={props.open} onClose={props.onClose} title="اطلاعات تماس" height={500}>
            {content}
        </Drawer>
    ) : (
        <Modal
            title="اطلاعات تماس"
            onCancel={props.onClose}
            onClose={props.onClose}
            open={props.open}
            height={'auto'}
            footer={<></>}
            // onOk={props.onClose}
            // okButtonProps={{ type: 'default' }}
            // cancelButtonProps={{ className: 'd-none-i' }}
        >
            {content}
        </Modal>
    );
}
